import styles from "@styles/profile/joinedCommunitiesTab.module.css";
import Image from "next/legacy/image";
import { COMMUNITY_MEMBER_ROLES } from "@utils/constants";
import classNames from "classnames/bind";
import classes from "../../src/socialMediaModule/styles/member.module.css";
import { Divider } from "@mui/material";
import { getMemberRole } from "@utils/constants";
import { time_ago } from "@utils/metrics/timeFunction";
import defaultProfilePic from "@public/assets/images/blank-profile-picture.png";
import Link from "next/link";
import { useRouter } from "next/router";
export default function CommunityProfileItem({
  data,
  onClickHandler
}) {
  const router = useRouter();
  const cx = classNames.bind(classes);
  const roleStyle = cx({
    owner: data.role === COMMUNITY_MEMBER_ROLES.OWNER,
    admin: data.role === COMMUNITY_MEMBER_ROLES.ADMIN,
    hide: data.role === COMMUNITY_MEMBER_ROLES.GENERAL
  });
  return <>
      <Link href={`/community/${data?.Community?.urlExtension}`} passHref className={styles.communityItem} rel="alternate" hrefLang={router.locale} onClick={() => {
      // track Event apply
    }} data-sentry-element="Link" data-sentry-source-file="CommunityProfileItem.jsx">
        <div className={styles.userDp}>
          <Image src={data.Community?.dp || defaultProfilePic} alt={`${data.Community?.name} dp`} width="80" height="80" objectFit="cover" style={{
          borderRadius: "50%"
        }} data-sentry-element="Image" data-sentry-source-file="CommunityProfileItem.jsx" />
        </div>

        <div className={`${styles.community_info}`}>
          <div className={styles.community_info_header}>
            <h5 className={`${classes.username}`}>{data.Community?.name}</h5>
            {data?.role !== COMMUNITY_MEMBER_ROLES.GENERAL && <span>&bull;</span>}
            <h6 className={`${classes.badge} ${roleStyle}`}>
              {getMemberRole(data?.role, router.locale)}
            </h6>
          </div>
          <small className={`${classes.timestamp}`}>
            {time_ago(data?.joiningTime)}
          </small>
        </div>
      </Link>
      {/* <hr className={styles.joinedCommunitiesHr} /> */}
      <Divider sx={{
      opacity: 0.25
    }} data-sentry-element="Divider" data-sentry-source-file="CommunityProfileItem.jsx" />
    </>;
}